import * as theme from "../../theme";
import Button from "react-bootstrap/Button";
import ReactPaginate from "react-js-pagination";
import {
  useEffect,
  useState,
  useCallback,
  useRef,
  useLayoutEffect,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditIconOutlined from "@material-ui/icons/CreateOutlined";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select from "react-select";
import { toast } from "react-toastify";
import { tr } from "date-fns/locale";
import Spinner from "react-bootstrap/Spinner";
import { Switch } from "@material-ui/core";
import "./insurercode.css";

import {
  addNewInsurerDetail,
  insurerMessageNull,
  insurerObjectNull,
  createInsurerModalClosed,
  createInsurerModalOpened,
  getAllInsurerList,
  getInsurerFailed,
  getInsurerListData,
  getInsurerModalOpen,
  getInsurerSuccess,
  getDeleteInsurer,
  getSelectedInsurerObj,
  isInsurerAdded,
  updateSingleInsurerObject,
} from "../../store/insurercode";
import Loader3Orange from "../../general/Loader3Orange";
import { insurerSelectList } from "../../helper/constants";
import { getBrokerInformation } from "../../store/broker";

const InsurerCode = () => {
  return <InsurerCodePane></InsurerCodePane>;
};

const itemsPerPage = 10; // Number of items to display per page
const InsurerCodePane = () => {
  const dispatch = useDispatch();

  const insurerListData = useSelector(getInsurerListData);
  const isAddInsurer = useSelector(isInsurerAdded);

  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [insurerList, setInsurerList] = useState([]);
  const [masterSwitch, setMasterSwitch] = useState(false);
  const [codeType, setCodeType] = useState("");
  const [codeName, setCodeName] = useState("");
  const brokerage = useSelector(getBrokerInformation);
  const languagePreference = brokerage.information.languagepreference || "en";

  const [isLoading, setIsLoading] = useState(false); // State variable to track loading state
  const [isLoadingRow, setIsLoadingRow] = useState(
    Array(insurerList?.length)?.fill(false)
  );
  const [isLoadingMasterSwitch, setIsLoadingMasterSwitch] = useState(false);
  useEffect(() => {
    dispatch(getAllInsurerList("carrierCode"));
  }, []);

  useEffect(() => {
    setInsurerList(insurerListData);
    const uniqueTypes = [...new Set(insurerListData?.map((item) => item.type))];
    const uniqueTypesString = uniqueTypes?.join(", ");
    setCodeType(uniqueTypesString);
    setCodeName(
      uniqueTypesString?.charAt(0).toUpperCase() +
        uniqueTypesString?.slice(1)?.replace(/Code/g, "")
    );
  }, [insurerListData]);

  useEffect(() => {
    if (insurerListData) {
      setInsurerList(insurerListData);
    }
  }, [isAddInsurer]);

  useEffect(() => {
    // Fetch the insurer list based on the current page
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedList = insurerListData?.slice(startIndex, endIndex);

    setInsurerList(paginatedList);
  }, [insurerListData, currentPage]);

  useEffect(() => {
    // Check if all insurers are set as default
    const allDefault = insurerList?.every((insurer) => insurer.isDefault);
    setMasterSwitch(allDefault);
  }, [insurerList]);

  const insurersuccess = useSelector(getInsurerSuccess);
  const onNewInsurerModelChangeHandle = () => {
    dispatch(insurerObjectNull());
    dispatch(createInsurerModalOpened());
  };

  const onUpdateInsurerModelChangeHandle = (insurer) => {
    dispatch(updateSingleInsurerObject(insurer));
    dispatch(createInsurerModalOpened());
  };

  const handleMasterSwitchChange = () => {
    const newMasterSwitchState = !masterSwitch;
    const confirmAction = window.confirm(
      "Are you sure you want to make it all as default ?"
    );

    if (confirmAction) {
      setIsLoadingMasterSwitch(true);

      setTimeout(() => {
        setMasterSwitch(newMasterSwitchState);
        const updatedInsurerListData = insurerList?.map((insurer) => ({
          ...insurer,
          isDefault: newMasterSwitchState,
        }));

        setInsurerList(updatedInsurerListData);

        setIsLoadingMasterSwitch(false);

        dispatch(addNewInsurerDetail(updatedInsurerListData))
          .then(() => dispatch(getAllInsurerList(codeType)))
          .catch((error) => {
            // Handle API call error here
          });
      }, 1000);
    } else {
      // Handle cancellation
    }
  };

  const handleIndividualSwitchChange = (index) => {
    const newIsDefaultState = !insurerList[index].isDefault;

    const updatedIsLoadingRow = [...isLoadingRow];
    updatedIsLoadingRow[index] = true;
    setIsLoadingRow(updatedIsLoadingRow);

    const updatedInsurerList = [...insurerList];
    const updatedInsurer = { ...updatedInsurerList[index] }; // Create a new object
    updatedInsurer.isDefault = newIsDefaultState;

    updatedInsurerList[index] = updatedInsurer; // Replace the old object with the updated one in the array

    setInsurerList(updatedInsurerList);
    const apiCall = dispatch(addNewInsurerDetail([updatedInsurer]))
      .then(() => {
        dispatch(getAllInsurerList(codeType));
      })
      .catch((error) => {
        // Handle API call error here
      });
    Promise.all([apiCall]).then(() => {
      // Set loading state for the specific row back to false
      const updatedIsLoadingRow = [...isLoadingRow];
      updatedIsLoadingRow[index] = false;
      setIsLoadingRow(updatedIsLoadingRow);
    });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const handleTypeSelect = (e) => {
    setCodeType(e?.value);
    if (e.value) {
      dispatch(getAllInsurerList(e?.value));
      setCodeName(e.label?.replace(/Code/g, ""));
    }
  };

  return (
    <div className="m-4">
      <div className="d-flex">
        <div
          className="m-4"
          style={{
            width: "100%",
          }}
        >
          <div
            className="d-flex justify-content-between"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            You can add and update {codeName} details
          </div>

          <div className="d-flex">
            {/* Master Switch */}
            {isLoadingMasterSwitch ? (
              <Spinner
                animation="border"
                size="lg"
                variant="danger"
                style={{ marginRight: "8px", marginTop: "4px" }}
              />
            ) : null}

            <Switch
              onChange={handleMasterSwitchChange}
              checked={masterSwitch}
            />
            <span
              className="ml-2"
              style={{
                fontFamily: "GibsonSemiBd",
                fontSize: "1.2vw",
              }}
            >
              Make it all as a Default
            </span>
          </div>
          <div className="d-flex justify-content-between my-2">
            <Select
              className="form-select col-sm-6"
              placeholder="Select Insurer Code"
              onChange={handleTypeSelect}
              value={insurerSelectList?.find((item) => item.value === codeType)}
              defaultValue={insurerSelectList?.find(
                (item) => item.value === "carrierCode"
              )}
              getOptionLabel={(option) => option.label[languagePreference]}
              options={insurerSelectList}
              styles={{
                control: (provided) => ({
                  ...provided,
                  width: "50%",
                  fontSize: "1.9vmin",
                  border: "4px solid light",
                  borderRadius: 15,
                  fontFamily: "GibsonRegular",
                }),
              }}
            />
            <Button
              style={{
                color: "white",
                height: "4vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_orange,
                border: 0,
                width: "10vw",
              }}
              onClick={onNewInsurerModelChangeHandle}
            >
              Add {codeName} Code
            </Button>
          </div>

          <div
            className="d-flex m-2"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "0.8vw",
            }}
          >
            <table className="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">{codeName} Name</th>
                  <th scope="col">{codeName} Code</th>
                  <th scope="col"> Default</th>
                  <th scope="col"> Action </th>
                </tr>
              </thead>
              <tbody>
                {insurerList &&
                  insurerList?.map((insurer, index) => {
                    return (
                      <tr key={index}>
                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "bold",
                            color: "rgb(63, 68, 90)",
                          }}
                        >
                          {insurer?.name}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "bold",
                            color: "rgb(63, 68, 90)",
                          }}
                        >
                          {insurer?.code}
                        </td>
                        <td>
                          <Switch
                            checked={insurer?.isDefault}
                            color="primary"
                            onChange={() => handleIndividualSwitchChange(index)}
                          />
                          {isLoadingRow[index] && (
                            <Spinner
                              animation="border"
                              size="sm"
                              variant="info"
                              style={{ marginLeft: "8px", marginTop: "4px" }} // Adjust margin as needed
                            />
                          )}
                        </td>

                        <td className="d-flex">
                          <div
                            className="text-center"
                            style={{
                              backgroundColor: theme.COLORS.secondary_skyblue,
                              width: "40px",
                              padding: 5,
                              borderRadius: 20,
                              color: "white",
                              cursor: "pointer",
                            }}
                          >
                            <EditIconOutlined
                              text="Update"
                              onClick={() =>
                                onUpdateInsurerModelChangeHandle(insurer)
                              }
                            />
                          </div>
                          <div
                            className="text-center "
                            style={{
                              backgroundColor: theme.COLORS.secondary_orange,
                              width: "40px",
                              padding: 5,
                              borderRadius: 20,
                              color: "white",
                              cursor: "pointer",
                            }}
                          >
                            <DeleteOutlineOutlinedIcon
                              onClick={() => {
                                const id = [insurer._id];
                                dispatch(getDeleteInsurer({ _id: id })).then(
                                  () => {
                                    dispatch(getAllInsurerList(codeType));
                                    setTimeout(() => {
                                      toast.success(`${codeName}  Deleted`);
                                    }, 200);
                                  }
                                );
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center ">
        <ReactPaginate
          activePage={currentPage}
          itemsCountPerPage={itemsPerPage}
          totalItemsCount={insurerListData?.length}
          pageRangeDisplayed={5} // Adjust as needed
          onChange={handlePageChange}
          itemClass="page-item-insurer"
          linkClass="page-link-insurer"
          containerClassName="pagination-insurer"
          subContainerClassName="pages pagination-insurer"
          activeClassName="active"
          pageClassName="page-item-insurer"
          pageLinkClassName="page-link"
          previousLabel="Previous"
          nextLabel="Next"
        />
      </div>

      <InsurerModal></InsurerModal>
    </div>
  );
};

const InsurerModal = (props) => {
  const dispatch = useDispatch();
  const newinsurerModalState = useSelector(getInsurerModalOpen);
  const getInsurer = useSelector(getSelectedInsurerObj);
  return (
    <Modal
      size="md"
      isOpen={newinsurerModalState}
      ariaHideApp={false}
      onRequestClose={() => dispatch(createInsurerModalClosed())}
      shouldCloseOnEsc={true}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "25rem",
          width: "40rem",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <InsurerModalPage></InsurerModalPage>
    </Modal>
  );
};

const InsurerModalPage = (props) => {
  const dispatch = useDispatch();
  const insurersuccess = useSelector(getInsurerSuccess);
  const getInsurer = useSelector(getSelectedInsurerObj);
  const isAddInsurer = useSelector(isInsurerAdded);
  const insurerFailedMessage = useSelector(getInsurerFailed);
  const [insurerName, setInsurerName] = useState(null);
  const [insurerCode, setInsurerCode] = useState(null);
  const [isDefault, setIsDefault] = useState(false);
  const [insurerType, setInsurerType] = useState([]);
  const brokerage = useSelector(getBrokerInformation);
  const languagePreference = brokerage.information.languagepreference || "en";

  const [nameError, setNameError] = useState("");
  const [codeError, setCodeError] = useState("");
  const [typeError, setTypeError] = useState("");
  const maxNameLength = 50;
  const maxCodeLength = 25;
  const getInsurertypeObject = insurerSelectList?.find(
    (item) => item.value === getInsurer?.type
  );

  useEffect(() => {
    setInsurerName(getInsurer?.name);
    setInsurerCode(getInsurer?.code);
    setIsDefault(getInsurer?.isDefault);
    setInsurerType(getInsurertypeObject);
  }, [getInsurer._id]);

  useEffect(() => {
    if (insurerFailedMessage?.error) {
      toast.error(insurerFailedMessage?.error, {
        style: {
          backgroundColor: theme.COLORS.toast_red,
          color: theme.COLORS.white_Indo,
        },
      });
    }
  }, [insurerFailedMessage]);

  useEffect(() => {
    if (isAddInsurer && insurersuccess) {
      toast.success(insurersuccess.message);
    }
  }, [isAddInsurer]);
  const handleTypeSelect = (e) => {
    setInsurerType(e);
  };
  const onAddButtonClick = async () => {
    const insurerDataObject = {
      name: insurerName,
      code: insurerCode,
      isDefault: isDefault, // Include isDefault value here
      type: insurerType?.value,
    };
    const insurerDataObjectForUpdate = {
      _id: getInsurer._id,
      name: insurerName,
      code: insurerCode,
      isDefault: isDefault,
      type: insurerType?.value,
    };
    setNameError("");
    setCodeError("");
    setTypeError("");

    let isValid = true;

    if (!insurerName || insurerName.trim() === "") {
      setNameError("Name is required");
      isValid = false;
    }

    if (!insurerCode || insurerCode.trim() === "") {
      setCodeError("Code is required");
      isValid = false;
    }

    if (!insurerType?.value) {
      setTypeError("Type is required");
      isValid = false;
    }

    if (isValid) {
      await dispatch(
        addNewInsurerDetail(
          getInsurer ? insurerDataObjectForUpdate : insurerDataObject
        )
      ).then(() => {
        setTimeout(() => {
          dispatch(createInsurerModalClosed());
          dispatch(getAllInsurerList(insurerType.value));
        }, 100);
      });
    }
  };

  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div
            className="text-center"
            style={{ fontFamily: "GibsonSemiBd", fontSize: "24px" }}
          >
            {getInsurer._id
              ? "Update a insurer detail"
              : "Add a new insurer detail"}
          </div>

          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="large"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(insurerObjectNull());
                dispatch(createInsurerModalClosed());
              }}
            ></CancelIcon>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-10">
            <form noValidate>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Name</label>
                <div className="col-sm-8">
                  <input
                    autoFocus
                    type="text"
                    id="name"
                    name="name"
                    className="form-control"
                    placeholder="Enter Name"
                    required
                    style={{ backgroundColor: "#fff" }}
                    onChange={(event) => {
                      if (event.target.value.length <= maxNameLength) {
                        setNameError("");
                        setInsurerName(event.target.value);
                      } else {
                        setNameError(
                          "Name cannot exceed " + maxNameLength + " characters."
                        );
                      }
                    }}
                    value={insurerName}
                  />
                  {nameError && <p style={{ color: "red" }}>{nameError}</p>}
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label"> Code</label>
                <div className="col-sm-8">
                  <input
                    autoFocus
                    type="text"
                    id="code"
                    name="code"
                    className="form-control"
                    placeholder="Enter Code"
                    required
                    style={{ backgroundColor: "#fff" }}
                    onChange={(event) => {
                      if (event.target.value.length <= maxCodeLength) {
                        setCodeError("");
                        setInsurerCode(event.target.value);
                      } else {
                        setCodeError(
                          "Code cannot exceed " + maxCodeLength + " characters."
                        );
                      }
                    }}
                    value={insurerCode}
                  />
                  {codeError && <p style={{ color: "red" }}>{codeError}</p>}
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-4 col-form-label"> Type</label>
                <Select
                  className="form-select col-sm-8"
                  placeholder="Select Insurer Code"
                  onChange={(e) => {
                    handleTypeSelect(e);
                    setTypeError("");
                  }}
                  value={insurerType}
                  getOptionLabel={(option) => option.label[languagePreference]}
                  options={insurerSelectList}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      width: "100%",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }),
                  }}
                />
                {typeError && (
                  <p style={{ color: "red", marginLeft: "12rem" }}>
                    {typeError}
                  </p>
                )}
              </div>
              <div className="form-group row">
                <div className="col-sm-8 d-flex align-items-center">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      id="isDefault"
                      name="isDefault"
                      className="form-check-input "
                      style={{
                        transform: "scale(2)",
                        marginLeft: "0.6px",
                      }}
                      onChange={(event) => {
                        setIsDefault(event.target.checked);
                      }}
                      checked={isDefault}
                    />
                    <span className="ml-5">Default</span>
                  </label>
                </div>
              </div>

              <div
                className="form-group row justify-content-center "
                style={{ paddingTop: "2%" }}
              >
                <div className="col-12">
                  <button
                    type="button"
                    style={{
                      backgroundColor: theme.COLORS.secondary_orange,
                      borderRadius: "10px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      onAddButtonClick();
                    }}
                  >
                    {getInsurer?._id
                      ? "Update Insurer Detail "
                      : "Add a new Insurer Detail"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};
export default InsurerCode;
